<template>
  <div>
      <div class="headerNav">
        <template v-if="type == 'home'">
          <a href="javascript:;" @click="scrollToSection('h1')" class="headerNavItem"><span>公司简介</span></a>
          <a href="javascript:;" @click="scrollToSection('h2')" class="headerNavItem"><span>服务领域</span></a>
          <a href="javascript:;" @click="scrollToSection('h3')" class="headerNavItem"><span>经典案例</span></a>
          <a href="javascript:;" @click="scrollToSection('h4')" class="headerNavItem"><span>资质荣誉</span></a>
          <a href="javascript:;" @click="scrollToSection('h5')" class="headerNavItem"><span>佳世动态</span></a>
          <a href="javascript:;" @click="scrollToSection('h6')" class="headerNavItem"><span>联系我们</span></a>
        </template>
        <template v-else>
          <router-link to="/asia/index?pageId=h1" class="headerNavItem"><span>公司简介</span></router-link>
          <router-link to="/asia/index?pageId=h2" class="headerNavItem"><span>服务领域</span></router-link>
          <router-link to="/asia/index?pageId=h3" class="headerNavItem"><span>经典案例</span></router-link>
          <router-link to="/asia/index?pageId=h4" class="headerNavItem"><span>资质荣誉</span></router-link>
          <router-link to="/asia/index?pageId=h5" class="headerNavItem"><span>佳世动态</span></router-link>
          <router-link to="/asia/index?pageId=h6" class="headerNavItem"><span>联系我们</span></router-link>
        </template>
      </div>
      <div class="headerTool">
        <div class="headerToolSearch">
          <div class="headerToolSearchBox">
            <input type="text" v-model="keyword" @keyup.enter="search()" />
          </div>
          <a href="javascript:;" @click="search()" class="headerToolSearchBtn"><i class="iconfont icon-sousuo"></i></a>
        </div>

        <a href="javascript:;" v-if="type == 'home'" @click="scrollToSection('h6')" class="headerToolBtn">Get in touch</a>
        <router-link to="/asia/index?pageId=h6" v-else  class="headerToolBtn">Get in touch</router-link>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    type: ''
  },
  data () {
    return {
      keyword:''
    }
  },

  mounted() {
    if(this.$route.query.keyword){
      this.keyword = this.$route.query.keyword
    }
  },
  methods:{
    scrollToSection(sectionId){
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }

    },


    search(){


      // if(this.keyword){
      //   this.$router.push({
      //     path:'/asia/serve?keyword='+this.keyword
      //   })
      //   location.reload()
      // }
      this.$router.push({
        path:'/asia/serve?keyword='+this.keyword
      })
      setTimeout(()=>{
        location.reload()
      },100)


    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/asia/nav.vue